import React from "react";
import ApplicationFormView from "./applicationFormView";
import Wrapper from "../../views/common/commonWrapper";
import { useQuery } from "@tanstack/react-query";
import { getApplicationsDetailById } from "../../utility/commonApi";
import { useNavigate, useParams } from "react-router-dom";
import { Spin } from "antd";
import backIcon from "../../assets/icons/back.svg";

function ApplicationFormViewParent() {
  const { id } = useParams();
  const navigate = useNavigate();

  const { data, isLoading } = useQuery({
    queryKey: ["applicationDetail", id],
    queryFn: () => getApplicationsDetailById(id),
    keepPreviousData: true,
    enabled: !!id,
  });

  // Render nothing until data loaded (and not loading)
  if (isLoading || !data) {
    return (
      <Wrapper>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%", // full viewport height
          }}
        >
          <Spin size="large" />
        </div>
      </Wrapper>
    );
  }
  const handleBack = () => {
    navigate(`/home?page=myApplications`, { replace: true });
  };
  return (
    <Wrapper>
      <div className="d-flex align-items-center justify-content-between">
        <div className="">
          <img
            onClick={() => handleBack()}
            className="back-button-link"
            src={backIcon}
            width={40}
            height={40}
          />
        </div>
        <div className="heading_div text-center">Application Detail</div>
        <div></div>
      </div>
      <ApplicationFormView data={data.data || {}} />
    </Wrapper>
  );
}

export default ApplicationFormViewParent;
